import { Component, input, output } from '@angular/core';
import { GroupedTpaCoverage } from '../../../features/tpa/models/tpa-group.model';
import { CardAction } from '../generic-card/models/card-config.interface';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { GenericCardComponent } from '../generic-card/generic-card.component';
import { DateOnlyPipe } from '../../pipes/date-only.pipe';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-census-lines-group-view',
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatCardModule,
    MatIconModule,
    GenericCardComponent,
    DateOnlyPipe,
    MatTooltip,
  ],
  templateUrl: './census-lines-group-view.component.html',
  styleUrl: './census-lines-group-view.component.scss',
})
export class CensusLinesGroupViewComponent {
  // Inputs
  groupViewData = input.required<GroupedTpaCoverage>();
  allExpanded = input<boolean>(false);

  // Outputs
  actionClick = output<CardAction>();
}
